import { render, staticRenderFns } from "./AppButton.vue?vue&type=template&id=bceb6774&scoped=true&"
import script from "./AppButton.vue?vue&type=script&lang=js&"
export * from "./AppButton.vue?vue&type=script&lang=js&"
import style0 from "./AppButton.vue?vue&type=style&index=0&id=bceb6774&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bceb6774",
  null
  
)

export default component.exports